import { Carousel } from "@fancyapps/ui/dist/carousel/carousel.js";
import { Lazyload } from "@fancyapps/ui/dist/carousel/carousel.lazyload.js";
import { Arrows } from "@fancyapps/ui/dist/carousel/carousel.arrows.js";
import { Thumbs } from "@fancyapps/ui/dist/carousel/carousel.thumbs.js";
import { Dots } from "@fancyapps/ui/dist/carousel/carousel.dots.js";

const mainBanner = document.querySelector('.main-banner');
if (mainBanner) {

    const mainCarousel = Carousel(mainBanner, {
        slidesPerPage: 1,
        transition: 'tween', // tween/fade
        tween: {
            tension: 150,
            friction: 2,
        },
        infinite: false,
        //Autoplay: {
        //    showProgressbar: false,
        //    timeout: 7000,
        //},
        Dots: {
            dotTpl: "<span data-carousel-go-to=\"%i\"></span>",
        },
        Lazyload: {
            preload: 0,
            showLoading: false,
        }
    }, {
        Lazyload,
        Dots,
        //Autoplay
    }).init();
}

const basicCarousels = document.querySelectorAll('.basic-carousel');
basicCarousels.forEach(carousel => {

    Carousel(carousel, {
        slidesPerPage: 1,
        infinite: false,
        fill: true,
        center: false,
        Lazyload: {
            preload: 0
        },
    }, {
        Lazyload
    }).init();
});

window.BuildDetailGallery = function () {
   
    window.DetailMainCarousel = Carousel(document.getElementById("detail-carousel"), {

        infinite: false,
        Thumbs: {
            type: "classic",
            Carousel: {

                vertical: true,
                center: (ref) => {
                    return ref.getTotalSlideDim() > ref.getViewportDim();
                },
                breakpoints: {
                    "(max-width: 1279px)": {
                        vertical: false,
                        center: true,
                    },
                },
            },
        },
        Lazyload: {
            preload: 0
        }
    }, {
        Lazyload,
        Arrows,
        Thumbs
    }).init();

}

const typeOf = document.body.getAttribute('data-type');
if (["detail", "cms"].includes(typeOf)) {
    import('@fancyapps/ui').then(({ Fancybox }) => {
        Fancybox.bind("[data-fancybox]", {
            placeFocusBack: false,
            hideScrollbar: false,
            Hash: false,
        });

        Fancybox.bind('[data-run-fancybox=""]', {
            autoFocus: false,
            trapFocus: false,
            placeFocusBack: false,
            groupAll: true,
            hideScrollbar: false
        });
    });
}


